import { render, staticRenderFns } from "./Academic_degree.vue?vue&type=template&id=09f79aad&scoped=true"
import script from "./Academic_degree.vue?vue&type=script&lang=js"
export * from "./Academic_degree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f79aad",
  null
  
)

export default component.exports